import {create} from 'zustand';
import {DocumentData} from 'firebase/firestore';
import {getDebug} from '../library/GeneralUse';

type FirestoreUserStore = {
	firestoreUser: DocumentData | null;
	setFirestoreUser: (newFirestoreUser: DocumentData | null) => void;
};

const DEBUG = getDebug('auth');

export const useFirestoreUserStore = create<FirestoreUserStore>((set) => ({
	firestoreUser: null,
	setFirestoreUser: (newFirestoreUser: DocumentData | null) => {
		DEBUG && console.trace(`setFirestoreUser(`, newFirestoreUser, `)`);
		set(() => ({firestoreUser: newFirestoreUser}));
	},
}));
